module.exports = __webpack_public_path__ + "static/img/SF-logo.28abb4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header/SF-logo.png
// module id = BXTu
// module chunks = 66